
import React from 'react';

const ServiceOverviewSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            安心・安全な農業ドローン運用をサポート
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            IDS教習所グループでは、DJI認定整備士による専門的な点検・整備サービスを提供しています。
            定期的なメンテナンスで機体の安全性を確保し、長期間にわたって安心してご利用いただけます。
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">DJI認定整備士</h3>
            <p className="text-gray-600">
              DJIから正式に認定された整備士が、厳格な基準に基づいて点検・整備を実施します。
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-check-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">定期点検</h3>
            <p className="text-gray-600">
              年次点検により機体の安全性を維持し、突然の故障や事故を未然に防ぎます。
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-tools-line text-2xl text-orange-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">緊急修理対応</h3>
            <p className="text-gray-600">
              故障や墜落時も3拠点が連携し、迅速な修理対応で業務への影響を最小限に抑えます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceOverviewSection;